import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isApiPaymentMethodCardSelector } from '../../../../redux/user/user.selectors';
import { PublicApi as PublicApiComponent } from './public-api';
const mapStateToProps = createStructuredSelector({
  isApiPaymentMethodCard: isApiPaymentMethodCardSelector
});
export const PublicApi = connect(mapStateToProps, null)(PublicApiComponent);